export default __webpack_public_path__ + "static/moreFeaturesBg-46e155530cd902d918699ff622633053.png";